import React, { Fragment } from "react";
import Header from "../../components/Header/Header";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import WdesignPageHero from "./components/WdesignPageHero";
import WdesignIntroSection from "./components/WdesignIntroSection";
import WdesignWhyChoose from "./components/WdesignWhyChoose";
import WdesignServicesSection from "./components/WdesignServicesSection";
import WdesignProcess from "./components/WdesignProcess";
import WdesignTechnologies from "./components/WdesignTechnologies";
import WdevStats from "../WebDevelopmentPage/components/WdevStats";
import WdevTestimonials from "../WebDevelopmentPage/components/WdevTestimonials";
import WdevCtaBanner from "../WebDevelopmentPage/components/WdevCtaBanner";
import "../WebDevelopmentPage/web-development.css";
import "./website-design.css";

const WebsiteDesignPage: React.FC = () => {
  return (
    <Fragment>
      <div className="wdev-page inner-page">
        <div className="body_wrap o-clip">
          <Header />
          <main>
            <WdesignPageHero />
            <WdesignIntroSection />
            <WdesignWhyChoose />
            <WdesignServicesSection />
            <WdesignProcess />
            <WdesignTechnologies />
            <WdevStats />
            <WdevTestimonials />
            <WdevCtaBanner />
          </main>
          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default WebsiteDesignPage;
